(function(){
  // API key restricted to farmsteady.com referrer in Google Cloud Console
  const KEY  = "AIzaSyCFZJBkOvTGhOGa8_E-6YfORp1w8j8dcrA";
  const MAX  = 3;          // videos to show
  const TTL  = 216e5;      // 6 h localStorage cache

  const thumb = (id, ttl) => {
    const d = document.createElement("div");
    d.className = "fs-thumb";
    d.style.backgroundImage = `url(https://i.ytimg.com/vi/${id}/maxresdefault.jpg)`;
    d.dataset.id  = id;
    d.dataset.ttl = ttl;
    return d;
  };

  const toIframe = el => {
    const id = el.dataset.id;
    if(!id) return;
    const f  = document.createElement("iframe");
    f.className   = "fs-playlist-iframe";
    f.loading     = "lazy";
    f.allow       = "accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share";
    f.allowFullscreen = true;
    f.title       = el.dataset.ttl;
    f.src         = `https://www.youtube.com/embed/${id}?playsinline=1&mute=0&modestbranding=1`;
    el.replaceWith(f);
  };

  async function getVideos(pid){
    const k = "fs-p-" + pid;
    try{
      const c = JSON.parse(localStorage.getItem(k)||"{}");
      if(Date.now()-c.t < TTL) return c.d;
    }catch{}
    const url  = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet,contentDetails&playlistId=${pid}&maxResults=3&key=${KEY}`;
    const data = await fetch(url).then(r=>r.json());
    const vids = (data.items||[]).map(i=>({
      id:          i.contentDetails.videoId,
      title:       i.snippet.title,
      desc:        i.snippet.description,
      thumb:       `https://i.ytimg.com/vi/${i.contentDetails.videoId}/maxresdefault.jpg`,
      uploadDate:  i.snippet.publishedAt
    }));
    try { localStorage.setItem(k, JSON.stringify({t:Date.now(), d:vids})); } catch(e) {}
    return vids;
  }

  function injectLD(videos){
    if(document.getElementById("fs-video-jsonld")) return;
    const logo = "https://farmsteady.com/cdn/shop/files/FarmSteady-Logo-One-Line-Website_1480x320.png";
    const ld   = {
      "@context":"https://schema.org",
      "@graph": videos.map(v=>({
        "@type":"VideoObject",
        name:v.title,
        description:v.desc,
        thumbnailUrl:v.thumb,
        uploadDate:v.uploadDate,
        embedUrl:`https://www.youtube.com/embed/${v.id}`,
        publisher:{
          "@type":"Organization",
          name:"",
          logo:{ "@type":"ImageObject", url:logo }
        }
      }))
    };
    const s   = document.createElement("script");
    s.id      = "fs-video-jsonld";
    s.type    = "application/ld+json";
    s.text    = JSON.stringify(ld);
    document.head.appendChild(s);
  }

  function mount(feed){
    const pid = feed.dataset.playlist;
    if(!pid) return;
    getVideos(pid).then(all=>{
      const vids = all.slice(0, MAX);
      vids.forEach(v=> feed.appendChild(thumb(v.id, v.title)));
      injectLD(vids);
      const io = new IntersectionObserver(ents=>{
        ents.forEach(e=>{ if(e.isIntersecting){ toIframe(e.target); io.unobserve(e.target);} });
      },{threshold:.1});
      feed.querySelectorAll(".fs-thumb").forEach(n=> io.observe(n));
    }).catch(()=>{ feed.innerHTML="<p style='padding:1rem'>Unable to load videos.</p>";});
  }

  (window.requestIdleCallback||((cb)=>setTimeout(cb,0)))(()=>{
    document.querySelectorAll(".fs-playlist-feed").forEach(mount);
  });
})();